// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3OasF","content":"ManualTimeModal_content__BnzBB"};